import { CONTACT_EMAIL, CONTACT_PHONE, FILTER_LABELS } from "../../constants"

export const INQUIRY_CONFIG = {
    EMAIL: CONTACT_EMAIL,
    SUBJECT: "Stock Inquiry - Bothra Enterprises",
    WHATSAPP_PHONE: CONTACT_PHONE.replace(/^\+/, ""),
}

export const generateInquiryBody = (selectedData, selections, url, ctBounds) => {
    let message = `Hi,\n\n`
    
    if (selectedData.length > 0) {
        message += `I am interested in the following ${selectedData.length} stones:\n`
        selectedData.forEach((stone, index) => {
            message += `${index + 1}. Stock No: ${stone.stock_no}\n`
        })
        message += `\n`
    } else {
        message += `I am interested in the stones listed here.\n\n`
    }

    // Filter summary
    const filterLines = []
    
    if (selections.ct && ctBounds) {
        const isCtFiltered = selections.ct.fromValue !== ctBounds.minValue
            || selections.ct.toValue !== ctBounds.maxValue
        if (isCtFiltered) {
            filterLines.push(`Ct: ${selections.ct.fromValue.toFixed(2)} to ${selections.ct.toValue.toFixed(2)}`)
        }
    }

    // Triple EX special logic
    const isEX = (key) => selections[key]?.size === 1 && selections[key].has("EX")
    const isTripleEX = isEX("cut") && isEX("polish") && isEX("symm")

    if (isTripleEX) {
        filterLines.push(`Triple EX`)
    } else {
        if (selections.cut?.size > 0) filterLines.push(`${FILTER_LABELS.cut}: ${Array.from(selections.cut).join(", ")}`)
        if (selections.polish?.size > 0) filterLines.push(`${FILTER_LABELS.polish}: ${Array.from(selections.polish).join(", ")}`)
        if (selections.symm?.size > 0) filterLines.push(`${FILTER_LABELS.symm}: ${Array.from(selections.symm).join(", ")}`)
    }

    if (selections.color?.size > 0) filterLines.push(`${FILTER_LABELS.color}: ${Array.from(selections.color).join(", ")}`)
    if (selections.clarity?.size > 0) filterLines.push(`${FILTER_LABELS.clarity}: ${Array.from(selections.clarity).join(", ")}`)

    if (selections.searchQuery) {
        filterLines.push(`Search: "${selections.searchQuery}"`)
    }

    if (filterLines.length > 0) {
        message += `Filters applied:\n${filterLines.map(line => `• ${line}`).join('\n')}\n\n`
    }

    message += `View online: ${url}\n\nPlease get back to me with more details.\n\nRegards,`
    
    return message
}
